import { getConfigFor } from '@/globals/config/helpers/getConfigFor';
import { translateInline } from '@/globals/translate/translateInline';
import { WebAPIOptionFilter } from '@/globals/webApiTypes/elements/WebAPIEvent';

export const eventFilterQueryKeys = getConfigFor.project<{
	subject: string;
	region: string;
}>({
	op: {
		subject: 'onderwerp',
		region: 'regio',
	},
	bgov: {
		subject: 'subject',
		region: 'region',
	},
});

export const eventFilterGroupKeys = Object.values(eventFilterQueryKeys);

export type EventFilterOption = {
	key: string;
	name: string;
};

export type EventFilters = {
	subjects: Array<EventFilterOption>;
	regions: Array<EventFilterOption>;
};

type EventFilterGroupDefinition = {
	key: keyof EventFilters;
	queryKeyRef: keyof typeof eventFilterQueryKeys;
	label: string;
	selectAllText: string;
};

export const filterGroups: Array<EventFilterGroupDefinition> = [
	{
		key: 'subjects',
		queryKeyRef: 'subject',
		label: translateInline({ en: 'Topic', nl: 'Onderwerp' }),
		selectAllText: translateInline({
			en: 'All topics',
			nl: 'Alle onderwerpen',
		}),
	},
	{
		key: 'regions',
		queryKeyRef: 'region',
		label: translateInline({ en: 'Region', nl: 'Regio' }),
		selectAllText: translateInline({
			en: 'All regions',
			nl: "Alle regio's",
		}),
	},
];

export const getEventFilterTypes = (
	filters: EventFilters,
): Array<WebAPIOptionFilter> => {
	return filterGroups.flatMap((filterGroup) => {
		const optionList = filters[filterGroup.key].map((option) => ({
			id: option.key,
			text: option.name,
			selected: false,
		}));

		if (optionList.length === 0) {
			return [];
		}

		return [
			{
				key: eventFilterQueryKeys[filterGroup.queryKeyRef],
				value: eventFilterQueryKeys[filterGroup.queryKeyRef],
				label: filterGroup.label,
				type: 'checkbox' as const,
				selectAllText: filterGroup.selectAllText,
				allSelectedText: filterGroup.selectAllText,
				optionList,
			},
		];
	});
};
